import React, { forwardRef, useState } from 'react';
import HealthOptions from './HealthOptions';
import PopUpRadioQuestions from '../PopUpRadioQuestions';
import Button from '@material-ui/core/Button';

const HealthClassPopUpContent = forwardRef((props, ref) => {
    const { onHide, onFieldChange } = props;
    const [healthClass, setHealthClass] = useState([0, 0, 0, 0, 0, 0, 0]);
    const [healthString, setHealthString] = useState('');
    const [healthQuestion, setHealthQuestion] = useState({
        health_impairments: '',
        agefamily_history: '',
        family_history: '',
        client_bloodpressure: '',
        client_cholesterol: '',
        client_participate: '',
        last3year_violations: ''
    });

    const setAnswer = (name = null, value = null, healthClassValue = null) => {
        let health = healthClass;
        if (currentStep === 8) {
            const healthClassObj = getHealthClassValue(health);
            onFieldChange(healthClassObj.healthString);
            onHide();
            return;
        }
        setHealthQuestion({ ...healthQuestion, [name]: value })
        health[currentStep - 1] = healthClassValue;
        setHealthClass(health);

        if (currentStep === 7) {
            const healthClassObj = getHealthClassValue(health);
            setHealthString(healthClassObj.fullString)
        }
        setCurrentStep(currentStep + 1)
    }

    const getHealthClassValue = (healthVal) => {
        let finalHealthClass = Math.min.apply(null, healthVal.filter(Boolean));
        let healthString = '';
        let fullString = '';
        switch (finalHealthClass) {
            case 3:
                healthString = "P";
                fullString = "Very healthy (Preferred)";
                break;
            case 2:
                healthString = "RP";
                fullString = "Above average health (Standard Plus)";
                break;
            case 1:
                healthString = "R";
                fullString = "Average health (Standard)";
                break;
            case 4:
            default:
                healthString = "PP";
                fullString = "Exceptionally healthy (Preferred Plus)";
                break;
        }
        return { healthString, fullString };

    }
    const [showbutton, setshowbutton] = useState(true);
    const [currentStep, setCurrentStep] = useState(1);

    const startOver = () => {
        let newState = {
            health_impairments: '',
            agefamily_history: '',
            family_history: '',
            client_bloodpressure: '',
            client_cholesterol: '',
            client_participate: '',
            last3year_violations: ''
        }
        setHealthQuestion(newState);
        setCurrentStep(1);
    }

    const onShowButon = () => {
        setshowbutton(false);
    }

    const goBack = () => {
        if (currentStep === 1) {
            setshowbutton(!showbutton)
        }
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    }

    const steps = [
        {
            step: 1,
            component: (
                <PopUpRadioQuestions question='Has your client had any major health impairments, such as diabetes, cancer or heart disease?'
                    options={[
                        { value: 'No', label: "No", rating: 0 },
                        { value: 'Yes', label: "Yes", rating: 2 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='health_impairments'
                    setAnswer={setAnswer}
                    value={healthQuestion.health_impairments}
                />
            )
        },
        {
            step: 2,
            component: (
                <PopUpRadioQuestions question='Does your client have any family history (parent or sibling) of heart disease or cancer?'
                    options={[
                        { value: 'No', label: "No", rating: 0 },
                        { value: 'Prior to Age 65', label: "Prior to Age 65", rating: 0 },
                        { value: 'Prior to Age 60', label: "Prior to Age 60", rating: 2 },
                        { value: 'Death Prior to Age 60', label: "Death Prior to Age 60", rating: 1 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='agefamily_history'
                    setAnswer={setAnswer}
                    value={healthQuestion.agefamily_history}
                />
            )
        },
        {
            step: 3,
            component: (
                <PopUpRadioQuestions question='Does your client have any family history (parent or sibling) of heart disease or cancer?'
                    options={[
                        { value: 'No', label: "No", rating: 0 },
                        { value: 'Yes', label: "Yes", rating: 2 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='family_history'
                    setAnswer={setAnswer}
                    value={healthQuestion.family_history}
                />
            )
        },
        {
            step: 4,
            component: (
                <PopUpRadioQuestions question='How is your client’s blood pressure?'
                    options={[
                        { value: 'Low (135/85 or Lower)', label: "Low (135/85 or Lower)", rating: 0 },
                        { value: 'Average (140/90 or Better)', label: "Average (140/90 or Better)", rating: 3 },
                        { value: 'High (145/90 or Higher)', label: "High (145/90 or Higher)", rating: 2 },
                        { value: 'Unsure', label: "Unsure", rating: 0 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='client_bloodpressure'
                    setAnswer={setAnswer}
                    value={healthQuestion.client_bloodpressure}
                />
            )
        },
        {
            step: 5,
            component: (
                <PopUpRadioQuestions question='How is your client’s cholesterol/HDL ratio?'
                    options={[
                        { value: 'Low (5.0 or Lower)', label: "Low (5.0 or Lower)", rating: 0 },
                        { value: 'Average (5.0 or Better)', label: "Average (5.0 or Better)", rating: 3 },
                        { value: 'High (6.0 or Higher)', label: "High (6.0 or Higher)", rating: 2 },
                        { value: 'Unsure', label: "Unsure", rating: 0 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='client_cholesterol'
                    setAnswer={setAnswer}
                    value={healthQuestion.client_cholesterol}
                />
            )
        },
        {
            step: 6,
            component: (
                <PopUpRadioQuestions question='Does your client participate in hazardous activities (work or recreational)?'
                    options={[
                        { value: 'No', label: "No", rating: 0 },
                        { value: 'Yes', label: "Yes", rating: 1 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='client_participate'
                    setAnswer={setAnswer}
                    value={healthQuestion.client_participate}
                />
            )
        },
        {
            step: 7,
            component: (
                <PopUpRadioQuestions question='How many moving violations in the last 3 years has your client had?' options={[
                    { value: 'None', label: "None", rating: 0 },
                    { value: '2 or Less', label: "2 or Less", rating: 0 },
                    { value: '3 or Less', label: "3 or Less", rating: 1 },
                ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='last3year_violations'
                    setAnswer={setAnswer}
                    value={healthQuestion.last3year_violations}
                />
            )
        },
        {
            step: 8,
            component: (
                <PopUpRadioQuestions
                    question="Your client’s estimated best health class they would likely qualify for is:"
                    onStartOver={startOver}
                    onBack={goBack}
                    setAnswer={setAnswer}
                    id='final_screen'
                    result={healthString}
                />
            )
        }
    ]
    const currentStepObj = steps.find(s => s.step === currentStep);

    return (
        <div ref={ref}>
            <div className='div-show mt-3'>
                <h3>Help Me Decide: {props.heading}</h3>
                <p className='py-1 my-3'>{props.details} </p>
            </div>
            {showbutton ? <div className='help-decide p-3' ><h4>Need help deciding?</h4>
                <p>Just answer a few simple questions.</p>
                <div className='button-hide'> <Button variant='contained' color='primary' onClick={onShowButon} >Get Started</Button></div></div> : currentStepObj.component}
            <HealthOptions onHide={onHide} onFieldChange={onFieldChange} healthClass={healthString} />
        </div>
    )
})

export default HealthClassPopUpContent;


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/HealthClassPopUp/HealthClassPopUpContent.js